import './basket.less'

require('./order-info/order-info');

$(function() {
	$(".bookmarks-link").tipTip({maxWidth: "auto", defaultPosition: "bottom"});
});
